import { render } from "./rolesPlataforma.vue?vue&type=template&id=e38bd5a0&scoped=true"
import script from "./rolesPlataforma.vue?vue&type=script&lang=js"
export * from "./rolesPlataforma.vue?vue&type=script&lang=js"

import "./rolesPlataforma.vue?vue&type=style&index=0&id=e38bd5a0&lang=scss&scoped=true"

import exportComponent from "C:\\xampp-80\\htdocs\\v2crmred\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e38bd5a0"]])

export default __exports__